import { render } from "./waitTimeCard.vue?vue&type=template&id=0c1d3bcb&scoped=true"
import script from "./waitTimeCard.vue?vue&type=script&lang=js"
export * from "./waitTimeCard.vue?vue&type=script&lang=js"

import "./waitTimeCard.vue?vue&type=style&index=0&id=0c1d3bcb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1d3bcb"]])

export default __exports__